import * as React from 'react';

import {SessionEditorHeader as Header} from './header/header';
import {SessionEditorSplitPane as SplitPane} from './split-pane/split-pane';
import {SessionEditorCodepad as Codepad} from './codepad/codepad';
import {SessionEditorFirepad as Firepad} from './firepad/firepad';
import {SessionEditorConsole as Console} from './console/console';
import {SessionEditorFooter as Footer} from './footer/footer';
import {SessionEditorRunCode as RunCode} from './run-code/run-code';

import {
    container       as cssContainer,
    containerHidden as cssContainerHidden,
} from './session-editor.module.sass';

export interface ISessionEditorProps {
    hidden?: boolean;
    connectionless?: boolean;
    initialCode: string;
    latestCode?: string;
    connected: boolean;
    updatedAt?: string;
    language: string;
    disabled: boolean;
    link: string;
    userId?: string;

    selectLanguage: (language: string) => void;
    languagePopover?: React.ReactNode;
    showConsoleScrollHint?: boolean;
    ackConsoleScroll?: () => void;
    runTests?: React.ReactNode;
    runCode: (value: string) => void;
    showRunCodeHint?: boolean;
}

export const SessionEditor: React.StatelessComponent<ISessionEditorProps> = ({
    hidden,
    connectionless,
    initialCode,
    latestCode,
    connected,
    updatedAt,
    language,
    disabled,
    link,
    userId,

    selectLanguage,
    languagePopover,
    showConsoleScrollHint,
    ackConsoleScroll,
    runTests,
    runCode,
    showRunCodeHint,
}: ISessionEditorProps) => (
    <div className={hidden ? cssContainerHidden : cssContainer}>
        <Header
            connected={connected}
            language={language}
            disabled={disabled}
            selectLanguage={selectLanguage}
        >
            {languagePopover}
        </Header>

        <SplitPane
            hidden={hidden}>
            {connectionless
                ?
                    <Codepad
                        initialCode={initialCode}
                        latestCode={latestCode}
                        updatedAt={updatedAt}
                        language={language}
                        disabled={disabled}
                        link={link}
                    />
                :
                    <Firepad
                        initialCode={initialCode}
                        language={language}
                        disabled={disabled}
                        link={link}
                        userId={userId}
                    />
            }

            <Console
                showConsoleScrollHint={showConsoleScrollHint}
                consoleScroll={ackConsoleScroll}
                hasTests={!!runTests}
            />
        </SplitPane>

        <Footer language={language}>
            <RunCode onClick={runCode} showHint={showRunCodeHint} />
            {runTests}
        </Footer>
    </div>
);
